import React, { createRef, Component } from 'react';
import { Link } from 'react-router-dom';

import { Switch } from 'components/cosmos/switch';
import Html from 'components/Html';
import { translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { MembershipTabs } from 'contexts/shellContext';
import { withShellContext } from 'hoc/withShellContext';
import flowRight from 'lodash/flowRight';
import { DatahubEventsService } from 'modules/app/services';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { ClickFreeModuleToggleSchema } from 'modules/app/services/datahubEvents/freeModule/clickFreeModuleToggleSchema';
import { SalesService } from 'modules/salesManager';
import PropTypes from 'prop-types';

import SignUpModal from './signUpModal/signUpModal';

import ModuleEditorEvents from '../../ModuleEditorEvents';

import './ModuleEditorFree.scss';

class ModuleEditorFree extends Component {
  static propTypes = {
    t: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    onClickSalesSection: PropTypes.func,
    isMembership: PropTypes.bool,
    isActivationFreeSignupEnabled: PropTypes.bool
  };

  state = {
    showFreeSignupModal: false,
    isFreeSignup: false
  };

  salesInfoRef = createRef();

  componentDidMount() {
    this.setIsFreeSignupActivated();
  }

  sendTrackerEvents = (value) => {
    ModuleEditorEvents.freeSignUpToggle(value);

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.CONTENT_MODULE_EDITOR,
        action: value
          ? EVENTS_INTERACTIONS.TOGGLE_ON
          : EVENTS_LABELS.TOGGLE_OFF,
        label: EVENTS_LABELS.CONTENT.CONTENT_MODULE_EDITOR.NEW_MODULE_FREE
      })
    });
  };

  handleFreeSignupModal = () => {
    this.setState((prevState) => ({
      showFreeSignupModal: !prevState.showFreeSignupModal
    }));
  };

  handleChange = (event) => {
    const { onChange, name } = this.props;
    const value = event.target.checked;

    onChange?.({
      target: {
        name,
        value
      }
    });

    if (value) {
      this.scrollToSalesInfo();
    }

    this.sendTrackerEvents(value);
  };

  setIsFreeSignupActivated = async () => {
    if (this.props.isActivationFreeSignupEnabled) {
      const isFreeSignup = await SalesService.getSignupAllowed();

      this.setState({ isFreeSignup });
    }
  };

  handleActivationFreeSignup = (event) => {
    const { isFreeSignup } = this.state;
    const { isActivationFreeSignupEnabled } = this.props;

    const schema = new ClickFreeModuleToggleSchema({
      freeSignUp: isFreeSignup
    });

    DatahubEventsService.sendEvent({ schema });

    const showModalToActivateFreeSignup =
      isActivationFreeSignupEnabled && !isFreeSignup && event.target.checked;

    if (showModalToActivateFreeSignup) {
      this.handleFreeSignupModal();
    } else {
      this.handleChange(event);
    }
  };

  activateFreeModule = () => {
    const { onChange, name } = this.props;

    this.setState({
      isFreeSignup: true
    });

    onChange?.({
      target: {
        name,
        value: true
      }
    });
  };

  handleFreeSignupClick = (event) => {
    const { isMembership, dispatchMembershipTabChange } = this.props;

    if (isMembership) {
      event.preventDefault();
      dispatchMembershipTabChange(MembershipTabs.FreeSignup);
    }
  };

  scrollToSalesInfo = () => {
    const scrollDelay = 100;

    setTimeout(() => {
      try {
        this.salesInfoRef?.current?.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      } catch {
        // do nothing.
      }
    }, scrollDelay);
  };

  render() {
    const { name, value, t } = this.props;

    return (
      <>
        <section>
          <label className="hot-form__label _text-2 _font-weight-bold _text-gray-900">
            {t('general.free_module', { checkOnlineEvent: true })}
          </label>
          <Html>
            {t('module_editor.free_signup.description', {
              checkOnlineEvent: true
            })}
          </Html>

          <section className="_mt-5 _d-flex _align-items-center _justify-content-between _justify-content-sm-start">
            <Switch
              isChecked={value}
              id={name}
              onChange={this.handleActivationFreeSignup}
            >
              {t('module_editor.free_signup.toggle', {
                checkOnlineEvent: true
              })}
            </Switch>
          </section>

          {value && (
            <section className="_mt-2">
              <div className="_font-weight-bold">{t('sales_manager.info')}</div>
              <div ref={this.salesInfoRef} className="_mt-2">
                <Html>
                  {t('module_editor.free_signup.info', {
                    checkOnlineEvent: true
                  })}
                </Html>
                {` `}
                <Link
                  to={ROUTES.FREE_SIGNUP}
                  onClick={this.handleFreeSignupClick}
                  className="_text-blue-dark"
                >
                  <Html>
                    {t('module_editor.free_signup.info_link', {
                      checkOnlineEvent: true
                    })}
                  </Html>
                </Link>
                {`. `}
                <Html>
                  {t('module_editor.free_signup.info_sales_page', {
                    checkOnlineEvent: true
                  })}
                </Html>
              </div>
            </section>
          )}
        </section>
        {this.state.showFreeSignupModal && (
          <SignUpModal
            onCloseModal={this.handleFreeSignupModal}
            enableFreeModule={this.activateFreeModule}
          />
        )}
      </>
    );
  }
}

export default flowRight(translate(), withShellContext)(ModuleEditorFree);

export { ModuleEditorFree };
